export const loginModal = {
  loginEmail: "Please input your email!",
  loginUserName: "Please input your username!",
  loginPassword: "Please input your password!",
  loginForgotPassword: "Forgot Password?",
  loginPasswordRecoverTitle: "Password Recovery",
  loginPasswordRecover: "Password recovery successful",
  loginPasswordRecoverMsg: "Check your email to reset your password",
  loginNoAccount: "Don't have an account?",
  loginRegister: "Sign up",
  loginUserNotFound: "User not found",
  loginIncorrectPasswordEmail: "User or Password not valid",
  loginSendBtn: "Send",
  loginSessionTitle: "Login",
  loginEmailPlaceholder: "Email",
  loginPasswordPlaceholder: "Password",
  loginRecoverEmail:
    "Don't remember the email you registered with? Recover your account by contacting our support team.",
  loginSupport: "Technical Support",
  loginRememberEmail: "Remember my email",
};
